import { render, staticRenderFns } from "./step7lizing.vue?vue&type=template&id=4f566b39&scoped=true"
import script from "./step7lizing.vue?vue&type=script&lang=js"
export * from "./step7lizing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f566b39",
  null
  
)

export default component.exports